<template>
  <div
    :class="$vuetify.breakpoint.xsOnly?'px-2 py-4 animate__animated animate__fadeIn':'pa-4 animate__animated animate__fadeIn'"
  >
    <h2 class="title_tab">
      รายงาน
      <v-btn
        outlined
        color="#156abd"
        :class="$vuetify.breakpoint.smAndUp?'float-right font-kanit-light mt-1':'float-right font-kanit-light'"
        @click="openReportRateMail()"
        :small="$vuetify.breakpoint.xsOnly"
      >
        <!-- <v-icon class="mr-1">mdi-telegram</v-icon> -->
        <img width="21px" :src="require('@/assets/image/telegram_ic.png')" />
        <span style="font-weight:300;" class="ml-1">ส่งรายงานหลายคน</span>
      </v-btn>
    </h2>

    <!-- <pre>{{all_email_data}}</pre> -->
    <div :class="$vuetify.breakpoint.xsOnly?'pt-3':'pt-5'">
      <v-row justify="center">
        <v-col cols="12" sm="12" md="8" lg="8" :class="$vuetify.breakpoint.xsOnly?'px-0':'py-1'">
          <v-card
            flat
            style="border-radius:10px"
            color="card_header"
            :tile="$vuetify.breakpoint.xsOnly"
          >
            <v-form ref="form" @submit.prevent="postEmail">
              <v-row
                :class="$vuetify.breakpoint.xsOnly?'pa-2 py-2':'py-2 px-3'"
                justify="center"
                align="center"
              >
                <v-col
                  :cols="extra_mobile?10:almost_mobile?8:9"
                  :class="extra_mobile?'py-0 px-1 pl-2':'py-0'"
                >
                  <v-text-field
                    v-model="email"
                    :rules="rule_email"
                    placeholder="example@gmail.com"
                    solo
                    flat
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="extra_mobile?2:almost_mobile?4:3"
                  :class="extra_mobile?'py-0 px-0  ':'py-0 pl-0'"
                  justify="center"
                >
                  <v-btn
                    dark
                    type="submit"
                    :block="!extra_mobile"
                    :fab="extra_mobile"
                    color="button"
                    :style="extra_mobile?'height:36px;width:36px;':'height:38px;'"
                    :class="$vuetify.breakpoint.xsOnly?extra_mobile?'mr-2 elevation-0':' font-kanit-light elevation-0':'elevation-0 font-kanit-light'"
                  >
                    <v-icon
                      :small="!$vuetify.breakpoint.xsOnly"
                      :x-small="$vuetify.breakpoint.xsOnly"
                      :class="almost_mobile?extra_mobile?'':'mr-1':'mr-2'"
                    >mdi-plus</v-icon>
                    <span
                      v-if="!extra_mobile"
                      :style="less_almost_mobile?'font-size:10px;':almost_mobile?'font-size:10px;':$vuetify.breakpoint.xsOnly?'font-size:12px;':''"
                    >เพิ่มอีเมล</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-row :class="$vuetify.breakpoint.xsOnly?'py-0':'py-2'">
            <v-col
              cols="12"
              v-for="(email,index) in all_email_data"
              :key="index"
              :class="$vuetify.breakpoint.xsOnly?'py-0':'py-1 '"
            >
              <v-card
                flat
                style="border-radius:10px"
                color="card_body"
                :tile="$vuetify.breakpoint.xsOnly"
              >
                <v-card-title class="py-1 pr-0">
                  <v-list-item-content>
                    <v-list-item-title class="contact-title">{{email.email}}</v-list-item-title>
                  </v-list-item-content>
                  <div v-if="!extra_mobile">
                    <v-btn
                      :x-small="almost_mobile"
                      text
                      color="#cc0000"
                      class="float-right font-kanit-light"
                      @click="deleteEmail(email.rate_email_id)"
                    >
                      <v-avatar
                        :size="almost_mobile?16:20"
                        style="color:#cc0000;background:white;border:solid 1px #cc0000"
                        class="mr-1"
                      >
                        <v-icon :size="almost_mobile?8:12">far fa-trash-alt</v-icon>
                      </v-avatar>ลบ
                    </v-btn>
                    <v-btn
                      :x-small="almost_mobile"
                      text
                      color="#156abd"
                      class="float-right font-kanit-light"
                      @click="openReportRateMail(email)"
                    >
                      <v-icon
                        class="mr-1"
                        :x-small="almost_mobile"
                        :size="almost_mobile?18:20"
                      >fab fa-telegram</v-icon>ส่งรายงาน
                    </v-btn>
                  </div>
                  <div v-if="extra_mobile" class="mr-1">
                    <v-btn
                      icon
                      color="#cc0000"
                      class="float-right"
                      @click="deleteEmail(email.rate_email_id)"
                    >
                      <v-avatar
                        size="20"
                        style="color:#cc0000;background:white;border:solid 1px #cc0000"
                      >
                        <v-icon size="12">far fa-trash-alt</v-icon>
                      </v-avatar>
                    </v-btn>
                    <v-btn
                      icon
                      color="#156abd"
                      class="float-right"
                      @click="openReportRateMail(email)"
                    >
                      <v-icon size="21">fab fa-telegram</v-icon>
                    </v-btn>
                  </div>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="0" md="4" lg="4" v-if="$vuetify.breakpoint.mdAndUp" style="padding-top:10%">
          <v-img src="../assets/image/bg_report.jpg"></v-img>
        </v-col>
      </v-row>
    </div>
    <DialogReportRateMail ref="report_ratemail" />
  </div>
</template>
<script>
import { rules } from "../assets/js/validate";
import DialogReportRateMail from "../views/dialogReportRateMail";
export default {
  components: { DialogReportRateMail },
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      all_email_data: [],
      email: "",
      rule_email: rules.email_rules,
      profile: {},
      btn_loading: false,
    };
  },

  mounted() {},
  created() {
    this.getData();
  },
  computed: {
    extra_mobile() {
      if (this.$vuetify.breakpoint.width < 345) {
        return true;
      } else {
        return false;
      }
    },

    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 505) {
        return true;
      } else {
        return false;
      }
    },
    less_almost_mobile() {
      if (
        this.$vuetify.breakpoint.width >= 345 &&
        this.$vuetify.breakpoint.width < 450
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    email(val) {
      this.all_email_data.forEach((element) => {
        if (val == element.email) {
          this.$swal.fire({
            icon: "warning",
            title: "อีเมลถูกใช้งานไปแล้ว",
            showConfirmButton: false,
            width: 500,
            timer: 1800,
            showCloseButton: true,
          });
        }
      });
    },
  },
  methods: {
    getData() {
      let all_email = [];
      this.all_email_data = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/rate/email", this.header_token)
        .then((response) => {
          all_email = response.data.result;

          if (response.data.result && response.data.status == "OK") {
            this.all_email_data = all_email;
          }
          // console.log(this.all_members);
        });
    },
    openReportRateMail(item) {
      this.$refs.report_ratemail.openDialogReportRateMail(item);
    },
    postEmail() {
      let check_already_email = false;
      this.profile = this.$session.get("profile");
      // console.log(this.profile[0].staff_id);
      if (this.$refs.form.validate()) {
        this.all_email_data.forEach((element) => {
          if (this.email == element.email) {
            check_already_email = true;
          }
        });
        if (check_already_email == false) {
          this.btn_loading = true;
          let data = {
            email: this.email,
            update_by: this.profile.staff_id,
          };
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/rate/email",
              data,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data.result);
              if (
                response.data.status == "OK" &&
                response.data.status != "FAIL"
              ) {
                this.btn_loading = false;
                this.$swal.fire({
                  icon: "success",
                  width: 500,
                  title: response.data.message,
                  text: "ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                  showConfirmButton: false,
                  timer: 2000,
                  showCloseButton: true,
                });
                this.email = "";
                setTimeout(() => {
                  this.$refs.form.resetValidation();
                }, 50);

                this.getData();

                // window.location.reload();
              } else if (response.data.status == "FAIL") {
                this.$swal.fire({
                  icon: "warning",
                  width: 500,
                  title: response.data.message,
                  text: "ไม่สามารถดำเนินการได้",
                  showConfirmButton: false,
                  timer: 2000,
                  showCloseButton: true,
                });
                this.btn_loading = false;
              }
            })
            .catch((err) => {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: "เกิดข้อผิดพลาด",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "อีเมลถูกใช้งานไปแล้ว",
            text: "อีเมลถูกใช้งานไปแล้ว กรุณาเปลี่ยนใหม่",
            showConfirmButton: false,
            width: 500,
            timer: 2000,
            showCloseButton: true,
          });
        }
      } else {
        this.$swal.fire({
          icon: "warning",
          text: "กรุณากรอกอีเมลให้ถูกต้อง",
          showConfirmButton: false,
          width: 500,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
    deleteEmail(id) {
      // console.log(id);
      this.$swal
        .fire({
          text: "ท่านต้องการยืนยันการลบหรือไม่?",
          // text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          width: 500,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/rate/email/" + id,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data.result);
                if (
                  response.data.status == "OK" &&
                  response.data.status != "FAIL"
                ) {
                  this.$swal.fire({
                    icon: "success",
                    width: 500,
                    title: response.data.message,
                    text: " ดำเนินการลบข้อมูลเรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 2000,
                    showCloseButton: true,
                  });

                  this.getData();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    width: 500,
                    title: response.data.message,
                    text: "ไม่สามารถลบข้อมูลได้",
                    showConfirmButton: false,
                    timer: 2000,
                    showCloseButton: true,
                  });
                }
              });
          }
        });
    },
  },
};
</script>

